/*=========================================================================================
  File Name: moduleOutbreaksMutations.js
  Description: Outbreaks Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  ADD_ITEM(state, item) {
  
     state.Opportunities.unshift(item)
  },


  SET_Opportunities(state, Opportunities) {
   
     try {

       //const parsedData = JSON.parse(Opportunities.data);
       state.Opportunities = Opportunities.Data;
     } catch (error) {
       console.error("Failed to parse Opportunities data JSON:", error);
       state.Opportunities = [];
     }
   },

  SET_OPPORTUNITY_FEES(state, fees) {
    state.OpportunityFees = fees;
  },
  ADD_FEE(state, fee) {
    state.OpportunityFees.push(fee);
  },


  UPDATE_FEE(state, fee) {
    const index = state.OpportunityFees.findIndex(f => f.Id === fee.Id);
    if (index !== -1) {

      state.OpportunityFees.splice(index, 1, fee);
    }
  },


  REMOVE_FEE(state, feeId) {
    state.OpportunityFees = state.OpportunityFees.filter(f => f.Id !== feeId);
  },
   UPDATE_Opportunities(state, Opportunity) {

    const OpportunityIndex = state.Opportunities.findIndex((p) => p.id == Opportunity.ID)
    Object.assign(state.Opportunities[OpportunityIndex], Opportunity)
  },
  REMOVE_ITEM(state, itemId) {
    
      const ItemIndex = state.Opportunities.findIndex((p) => p.id == itemId)
      state.Opportunities.splice(ItemIndex, 1)
  },
  GET_ITEM_BY_ID(state, Opportunity){
  
    try {
      //const parsedData = JSON.parse(Opportunity.data);
    
      state.Opportunity = Opportunity;
    } catch (error) {
      console.error("Failed to parse Opportunity data JSON:", error);
      state.Opportunity = {};
    }
  },
   SET_IdentityCardExists(state, exists) {
  
    state.identityCardExists = exists;
  },
  SET_OPPORTUNITY_DOCUMENTS(state, docs) {
    state.OpportunityDocuments = docs;
  },
  ADD_OPPORTUNITY_DOCUMENT(state, doc) {
    state.OpportunityDocuments.push(doc);
  },
  UPDATE_OPPORTUNITY_DOCUMENT(state, doc) {
    const index = state.OpportunityDocuments.findIndex(d => d.Id === doc.Id);
    if (index !== -1) state.OpportunityDocuments.splice(index, 1, doc);
  },
  REMOVE_OPPORTUNITY_DOCUMENT(state, docId) {
    state.OpportunityDocuments = state.OpportunityDocuments.filter(d => d.Id !== docId);
  },
  SET_TAX_RATE(state, vatPercentage) {
  state.vatPercentage = vatPercentage;
}
}
